<form class="search-criteria-form" (submit)="$event.preventDefault()">
  <mat-form-field>
    <mat-label>Search</mat-label>
    <input
      #searchInput
      (keyup.enter)="triggerSearch()"
      type="text"
      placeholder="Type to search"
      aria-label="Search"
      matInput
      [formControl]="queryTermControl"
      [matAutocomplete]="auto"
    />
    <mat-icon matSuffix (click)="triggerSearch()" (keyup.enter)="triggerSearch()" class="material-symbols-outlined"
      >search</mat-icon
    >
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="triggerSearch()">
      @for (option of autocompleteOptions | async; track option) {
        <mat-option [value]="option">
          {{ option }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</form>
@if (sort?.length) {
  <div class="filter-section sort-by">
    <div>
      <mat-form-field>
        <mat-label>Sort by:</mat-label>
        <mat-select [formControl]="sortControl">
          @for (option of sort; track option.key) {
            <mat-option [value]="option.key">
              {{ option.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
}
<div class="filters-container">
  <div class="filter-section applied-filters">
    <div class="filter-section-header" id="lblAppliedFilters">Applied Filters:</div>
    <mat-chip-set #appliedFiltersList aria-labelledby="lblAppliedFilters">
      @for (filter of filters; track filter.key) {
        @for (chip of filter.selected(); track chip.value) {
          <mat-chip disableRipple (removed)="filter.remove(chip.value)" class="applied-filter">
            <b>{{ filter.label }}:</b> {{ chip.label }}
            <button matChipRemove [attr.aria-label]="'remove ' + chip.label">
              <mat-icon class="material-symbols-outlined">cancel</mat-icon>
            </button>
          </mat-chip>
        }
      }
      @if (hasFilters) {
        <mat-chip disableRipple (click)="clearAllFilters()" (keyup.enter)="clearAllFilters()" class="clear-all-filters">
          <mat-icon matChipAvatar class="material-symbols-outlined">cancel</mat-icon>
          Clear filters
        </mat-chip>
      }
    </mat-chip-set>
  </div>

  <div class="filter-section filters">
    <div class="filter-section-header">Filter by:</div>
    <ng-container *ngComponentOutlet="me; injector: injector"></ng-container>

    @for (filter of visibleFilters; track filter.key) {
      <mat-expansion-panel
        class="filter-panel"
        [expanded]="isFilterActive(filter)"
        (opened)="syncFilterUI(filter)"
        (expandedChange)="setFilterExpanded(filter, $event)"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>{{ filter.label }}</mat-panel-title>
        </mat-expansion-panel-header>
        <ng-container *ngComponentOutlet="filter.component; inputs: {filter}; injector: injector"></ng-container>
      </mat-expansion-panel>
    }
  </div>
</div>
